import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import DynamicTableFilters from "../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters"
import Toggle from "../../../common/AdminCommonComponents/Toggle/Toggle"
import DynamicCardRow from "../../DynamicCardRow/DynamicCardRow"

const ResourceManagement = ({ setAddNewResource }) => {
  const cardsData = [
    { title: "TOTAL Resources".toUpperCase(), value: 0 },
    { title: "E-books".toUpperCase(), value: 0 },
    { title: "Document/Guides".toUpperCase(), value: 0 },
    { title: "Videos".toUpperCase(), value: 0 },
  ]

  const tableData = [
    { resourceID: "R001", name: "Social Media Handbook", type: "E-Book", assignedTo: "Sellers", uploadDate: '01-11-2024', status: <Toggle theme="yellow" /> },
    { resourceID: "R001", name: "Social Media Handbook", type: "E-Book", assignedTo: "Sellers", uploadDate: '01-11-2024', status: <Toggle theme="yellow" /> },
    { resourceID: "R001", name: "Social Media Handbook", type: "E-Book", assignedTo: "Sellers", uploadDate: '01-11-2024', status: <Toggle theme="yellow" /> },
    { resourceID: "R001", name: "Social Media Handbook", type: "E-Book", assignedTo: "Sellers", uploadDate: '01-11-2024', status: <Toggle theme="yellow" /> },
    { resourceID: "R001", name: "Social Media Handbook", type: "E-Book", assignedTo: "Sellers", uploadDate: '01-11-2024', status: <Toggle theme="yellow" /> },
    { resourceID: "R001", name: "Social Media Handbook", type: "E-Book", assignedTo: "Sellers", uploadDate: '01-11-2024', status: <Toggle theme="yellow" /> },
  ]

  const columns = [
    {
      name: "Resource ID",
      selector: (row) => row.resourceID,
    },
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Type",
      selector: (row) => row.type,
    },
    {
      name: "Assigned to",
      selector: (row) => row.assignedTo,
    },
    {
      name: "Upload Date",
      selector: (row) => row.uploadDate,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      center: true,
    },
    {
      name: "Actions",
      cell: () => (
        <div className="d-flex align-items-center gap-2">
          <button style={{ all: "unset" }}>Edit</button>
          <button style={{ all: "unset" }}>Delete</button>
          <button style={{ all: "unset" }}>View</button>
        </div>
      ),
    },
  ]

  return (
    <>
      <div className="shadow bg-white p-3 mt-3">
        <div className="mb-3 fw-semibold fs-4">Overview</div>
        <DynamicCardRow cards={cardsData} />
      </div>

      <div className="my-3">
        <DynamicButton theme="blue" onClick={() => setAddNewResource(prev => !prev)}>Create Module</DynamicButton>
      </div>

      <div className="bg-white shadow p-1">
        <DynamicTableFilters componentName="Content Management Training And Resources" />
      </div>
        <DynamicDatatable data={tableData} columns={columns} type="yellow" pagination />
    </>
  )
}

export default ResourceManagement
